import { composeClassNames } from "@faedev/editor-utils";
import { Col, Row } from "react-bootstrap";
import Heading from "src/components/Heading";
import gutter from "src/functions/gutter";
import { sAlign } from "src/styles/sAlign.module.scss";
import { sList } from "src/styles/sList.module.scss";

function UserTermsPrivacySk11() {
  return (
    <div>
      <Heading
        type="h3"
        title={
          <>
            {`XI.`}
            <br />
            {`Záverečné ustanovenia`}
          </>
        }
        className={composeClassNames([sAlign, "center"])}
        style={gutter(`margin`, `top`, `md`)}
      />
      <Row>
        <Col sm={6} xs={12}>
          <ol className={sList}>
            <li>{`Ak vzťah založený zmluvou obsahuje medzinárodný (zahraničný) prvok, potom si strany stanovujú, že vzťah sa riadi českým právom. Týmto nie sú dotknuté práva spotrebiteľa vyplývajúce z všeobecne záväzných právnych predpisov`}</li>
            <li>{`Poskytovateľ nie je vo vzťahu k používateľovi viazaný žiadnymi kódexmi správania v zmysle ustanovenia § 1826 ods. 1 písm. e) Občianskeho zákonníka.`}</li>
            <li>{`Na mimosúdne riešenie spotrebiteľských sporov zo zmluvy je príslušná Česká obchodná inšpekcia, so sídlom Štěpánská 567/15, 120 00 Praha 2, IČO: 000 20 869, internetová adresa: http://www.coi.cz.`}</li>
            <li>{`Používateľ týmto preberá na seba nebezpečenstvo zmeny okolností v zmysle § 1765 ods. 2 Občianskeho zákonníka.`}</li>
          </ol>
        </Col>
        <Col sm={6} xs={12}>
          <ol start={5} className={sList}>
            <li>{`V prípade, že je niektoré ustanovenie obchodných podmienok neplatné alebo neúčinné, alebo sa takýmto stane, namiesto neplatných ustanovení nastúpi ustanovenie, zmysel ktorého sa neplatnému ustanoveniu čo najviac približuje. Neplatnosťou alebo neúčinnosťou jedného ustanovenia nie je dotknutá platnosť ostatných ustanovení. Zmeny a doplnky kúpnej zmluvy či obchodných podmienok vyžadujú písomnú formu.`}</li>
            <li>{`Zmluva vrátane obchodných podmienok je archivovaná poskytovateľom v elektronickej podobe a nie je prístupná.`}</li>
            <li>{`Prílohu obchodných podmienok tvorí vzorový formulár na odstúpenie od zmluvy.`}</li>
          </ol>
        </Col>
      </Row>
    </div>
  );
}

export default UserTermsPrivacySk11;
